import './FieldInput.css';

import { cn } from '##/utils/bem';

export const cnFieldInput = cn('FieldInput');
